import { lit } from '../../utils/literal.js';

/**
 * Drawer UI 类型
 *
 * @public
 */
const DrawerType = {
    /**
     * 透明 Drawer
     */
    TRANSPARENT: lit('transparent'),
    /**
     * 面板 Drawer
     */
    PANEL: lit('panel'),
};
/**
 * Drawer 动画类型
 *
 * @public
 */
const DrawerAnimation = {
    /**
     * 滑动进入
     */
    SLIDE_IN: lit('slideIn'),
    /**
     * 淡入淡出
     */
    FADE_IN: lit('fadeIn'),
};
function isDraggableOptions(options) {
    return typeof options === 'object';
}

export { DrawerAnimation, DrawerType, isDraggableOptions };
//# sourceMappingURL=drawer-info.js.map
